import contains from './contains';
/**
 * Returns whether the provided element or an element inside itself is the
 * current active element.
 * @param element
 */

export default function isActiveElement(element) {
  var _document = document,
      activeElement = _document.activeElement;
  return element && (element === activeElement || contains(element, activeElement));
}
//# sourceMappingURL=isActiveElement.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/blaze-consumer/~/@flowio/browser-helpers/lib/esm/isActiveElement.js
// module id = 480
// module chunks = 0 1